<template>
  <div class="appNav-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="下拉框" name="1">
          <div class="setting-item clearFloat mb16">
            <cx-check-box :value="showNav" @change="changeShowNav">展开多级菜单</cx-check-box>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { getAllElementsInColsInLayoutComponent } from "utils"
export default {
  name: "appNav-options-setting",
  props: { options: Object },
  data() {
    return {
      activeNames: [],
      showNav: false,
      navEl: null,
      navIds: null
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {
    changeShowNav(val) {
      this.showNav = val
      this.resetNavLeft()
      this.navEl.style.display = val ? "block" : "none"
    },
    resetNavLeft() {
      const top = this.getAttrById(this.$store.state[this.request_prefix], this.navIds).top
      const x =
        this.navEl.parentNode.getBoundingClientRect().x -
        document.getElementById("container_0").getBoundingClientRect().x
      const idsStr = this.$event.getIdsByStrId({
        ...this.navIds
      })
      document.getElementsByClassName(idsStr)[0].style.transform = `translate(-${x}px, ${top}px)`
    },
    checkNav() {
      const allElementInLayout = getAllElementsInColsInLayoutComponent(this.options.rows)
      this.navIds = null
      //找到预设的纵向导航
      for (let uid in allElementInLayout) {
        if (this.navIds) break
        const elementOptions = allElementInLayout[uid].elementOptions
        for (let i = 0; i < elementOptions.length; i++) {
          const elementInLayout = elementOptions[i]
          if (elementOptions[i]?.pluginMark === "nav") {
            this.navIds = {
              uid,
              elementInLayoutId: elementInLayout.elementInLayoutId,
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id
            }
          }
        }
      }
      if (this.navIds) {
        const idsStr = this.$event.getIdsByStrId({
          ...this.navIds
        })
        this.navEl = document.getElementsByClassName(idsStr)[0]
        this.showNav = this.navEl.style.display === "block"
      }
    }
  },
  mounted() {
    this.checkNav()
  }
}
</script>

<style scoped lang="scss">
</style>
